import React, { Fragment, useCallback, useEffect, useMemo, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { roundsWinBetTypes } from '../../../store/roundsWinBetTypes';
import { COLOR_BY_WIN_TYPE, ROUND_WIN_TYPE_VIEW } from '../../../enums/betTypesEnum';
import { betShopStatisticViewTypes } from '../../../enums/statisticTypes';

export const BottomStatistic = observer(({ statisticList, statisticType }) => {
  const { winBetTypes } = roundsWinBetTypes;
  const statisticContainer = useRef();

  const scrollToMyRef = useCallback(() => {
    if (!statisticContainer.current) return;
    statisticContainer.current.scrollLeft =
      statisticContainer.current.scrollWidth - statisticContainer.current.clientWidth;
  }, [statisticContainer]);

  useEffect(() => {
    scrollToMyRef();
  }, [scrollToMyRef, winBetTypes]);

  const StatisticItem = useCallback(
    ({ item }) => {
      return (
        <div
          className={`bb-chip ${COLOR_BY_WIN_TYPE[ROUND_WIN_TYPE_VIEW[item?.winType]]} ${
            betShopStatisticViewTypes[statisticType]
          } sm`}
        />
      );
    },
    [statisticType]
  );

  const memoRowList = useMemo(() => {
    let accIndex = 0;
    const list = statisticList.reduce((acc, cur, index) => {
      if (!index) {
        acc.push([cur]);
      } else if (acc[accIndex].length < 14) {
        acc[accIndex].push(cur);
      } else {
        accIndex += 1;
        acc.push([cur]);
      }

      return acc;
    }, []);
    const emptylistCount = 10 - list.length;
    if (emptylistCount) {
      for (let i = 0; i < emptylistCount; i += 1) {
        list.push(new Array(7).fill(null));
      }
    }
    return list;
  }, [statisticList]);

  return (
    <div className='bb-bet-section-row-bottom-col'>
      <div className='bb-bet-section-row-bottom-col-inside' ref={statisticContainer}>
        {memoRowList.map((item, itemIndex) => {
          return (
            <Fragment key={`id`.concat(itemIndex)}>
              {item.map((cur, index) => {
                if (index < 7 && !(index % 2)) {
                  if (index && !(index % 6)) {
                    return (
                      <div
                        key={`${itemIndex}`.concat(index)}
                        className='bb-bet-bottom-section-item'
                      >
                        <StatisticItem item={item[index]} />
                        <StatisticItem />
                        <StatisticItem item={item[index + 7]} />
                      </div>
                    );
                  }
                  return (
                    <div key={`${itemIndex}`.concat(index)} className='bb-bet-bottom-section-item'>
                      <StatisticItem item={item[index]} />
                      <StatisticItem item={item[index + 1]} />
                      <StatisticItem item={item[index + 7]} />
                      <StatisticItem item={item[index + 8]} />
                    </div>
                  );
                }
                return null;
              })}
            </Fragment>
          );
        })}
      </div>
    </div>
  );
});
